import { appWithTranslation } from "next-i18next";

import Layout from "../components/layout/Layout";
import "../styles/globals.css";
import { ApolloProvider } from "@apollo/client";
import client from "../apollo-client";
import { SessionProvider } from "next-auth/react";
import StoreAuthData from "../components/StoreAuthData";
import React, { useEffect } from "react";
import { GlobalStateProvider } from "../context/GlobalStateContext";

function MyApp({ Component, pageProps }) {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "public/sw-register.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);
  return (
    <GlobalStateProvider>
      <SessionProvider>
        <StoreAuthData />
        <ApolloProvider client={client}>
          <Layout>
            <Component {...pageProps} />
          </Layout>
        </ApolloProvider>
      </SessionProvider>
    </GlobalStateProvider>
  );
}

export default appWithTranslation(MyApp);
